import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogOption, DialogResult } from "./dialog.models";

export interface DialogData {
  message: string;
  action: string;
  title: string;
  showCancel: boolean;
  confirmColor: string;
  option?: DialogOption;
}

@Component({
  selector: "lib-dialog",
  standalone: false,
  templateUrl: "./dialog.component.html",
  styleUrls: ["./dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogComponent {
  optionChecked = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.optionChecked = data.option?.checked ?? false;
  }

  get confirmResult(): true | DialogResult {
    if (!this.data.option) {
      return true;
    }

    return {
      confirmed: true,
      optionChecked: this.optionChecked
    };
  }
}
